import { COLUMN_CARD_TYPES_COUNT, COLUMN_NAME, COLUMN_SITE_MASK, COLUMN_TAG_MASK } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const CardFormatsColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site Card Mask",
        accessor: "tagMask",
        isNumeric: false,
        id: 1,
        sortByName: "tfTagMask",
        sortDirection: "asc",
        active: true,
        translationKey: "tagmask",
        columnId: COLUMN_TAG_MASK,
    },
    {
        heading: "Site Mask",
        accessor: "siteMask",
        isNumeric: false,
        id: 2,
        sortByName: "tfSiteMask",
        sortDirection: "asc",
        active: true,
        translationKey: "siteMask",
        columnId: COLUMN_SITE_MASK,
    },
    {
        heading: "Card Types",
        accessor: "cardTypes",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "cardTypes",
        columnId: COLUMN_CARD_TYPES_COUNT,
    },
];

export default CardFormatsColumns;
